module.exports = __webpack_public_path__ + "77fff0f38af2d5bd50a9b19211ff4fb3.png";